import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

export const EmptyStateContainer = styled.div`
  flex: 1;
  display: flex;
  padding-top: var(${SpacingToken.Spacing10});
  justify-items: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: var(${DesignToken.ContentBasicPrimary});
  gap: var(${SpacingToken.Spacing4});
`;
